// extracted by mini-css-extract-plugin
module.exports = {"camera":"EditUserTableRow_camera__1Pc7e","cellBottomBorder":"EditUserTableRow_cellBottomBorder__2ls54"};